import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  SubdistrictPayloadSchema,
  subdistrictPayloadSchema,
  useSubdistrict,
} from "@/api/subdistrict";
import { Loading } from "@/components/ui/loading";
import { SubdistrictFormFields } from "./SubdistrictFormFields";
import { FormContainer } from "@/components/form/form-container";
import { Anchor } from "@/components/ui/anchor";

export function SubdistrictDetailForm({ id }: { id: string }) {
  const {
    data: subdistrict,
    isPending: isLoadingData,
    isError,
  } = useSubdistrict({
    id,
  });
  const form = useForm<SubdistrictPayloadSchema>({
    resolver: zodResolver(subdistrictPayloadSchema),
    defaultValues: {
      subdistrictCode: subdistrict?.subdistrictCode,
      subdistrictName: subdistrict?.subdistrictName,
      city: subdistrict?.city,
    },
    values: subdistrict,
  });

  if (isLoadingData) {
    return <Loading />;
  }

  if (!subdistrict) {
    return <div>Subdistrict not found</div>;
  }

  if (isError) {
    return <div>Failed to load subdistrict</div>;
  }

  return (
    <FormContainer form={form}>
      <SubdistrictFormFields isDisabled />
      <div className="ml-auto">
        <Anchor href="/master-data/district" mood="axiata-blue">
          Back
        </Anchor>
      </div>
    </FormContainer>
  );
}
